

import React from 'react'

const OrderRatings = ({data}) => {
    
    console.log("data")
    console.log(data)
  return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4">
      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>Id</th>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>restaurantId</th>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>review</th>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>stars</th>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>riderId</th>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>riderStars</th>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>riderReview</th>
              <th className='px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide'>userId</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index)=>(
              <tr key={item.id || index} className='border border-gray-300 hover:bg-gray-50'>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.id}</td>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.restaurantId}</td>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.review ? item.review : "-"}</td>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.stars ? item.stars : "-"}</td>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.riderId ? item.riderId : "-"}</td>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.riderStars ? item.riderStars : "-"}</td>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.riderReview ? item.riderReview : "-"}</td>
                <td className='text-center px-2 md:px-5 py-2 text-[10px] md:text-sm'>{item.userId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default OrderRatings